var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "saas-page people-page linear-command-page sip-list-page" },
    [
      _c(
        "div",
        { staticClass: "saas-hero card-saas people-page__hero sip-list-head" },
        [
          _c("div", { staticClass: "saas-hero__main" }, [
            _c(
              "p",
              { staticClass: "saas-hero__crumb" },
              [
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v(_vm._s(_vm.trans("general.home"))),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "px-1" }, [_vm._v("/")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.trans("user.user")))]),
              ],
              1
            ),
            _vm._v(" "),
            _c("h1", { staticClass: "saas-hero__title" }, [
              _vm._v(_vm._s(_vm.trans("user.user"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "people-page__actions" }, [
            _c(
              "button",
              {
                staticClass:
                  "btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline",
                attrs: {
                  type: "button",
                  "aria-controls": "user-filter-panel",
                  "aria-expanded": _vm.showFilterPanel ? "true" : "false",
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.showFilterPanel = !_vm.showFilterPanel
                  },
                },
              },
              [
                _c("admin-icon", {
                  attrs: { name: "sliders", "aria-hidden": "true" },
                }),
                _c("span", [_vm._v(_vm._s(_vm.trans("general.filter")))]),
              ],
              1
            ),
            _vm._v(" "),
            _vm.hasPermission("create-user")
              ? _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "b-modal",
                        rawName: "v-b-modal.modal-1",
                        modifiers: { "modal-1": true },
                      },
                    ],
                    staticClass:
                      "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                    attrs: { type: "button" },
                  },
                  [
                    _c("admin-icon", {
                      attrs: { name: "plus", "aria-hidden": "true" },
                    }),
                    _c("span", [_vm._v(_vm._s(_vm.trans("user.create_user")))]),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "people-command-grid sip-kpi-strip" }, [
        _c("section", { staticClass: "people-command-card sip-kpi" }, [
          _c("span", { staticClass: "people-command-card__label" }, [
            _vm._v(_vm._s(_vm.trans("user.user"))),
          ]),
          _vm._v(" "),
          _c("strong", [_vm._v(_vm._s(_vm.users.total || 0))]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.users.total
                  ? _vm.trans("general.total_result_found", {
                      count: _vm.users.total,
                    })
                  : _vm.trans("user.module_info_description")
              )
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "section",
          {
            staticClass:
              "people-command-card people-command-card--muted sip-kpi",
          },
          [
            _c("span", { staticClass: "people-command-card__label" }, [
              _vm._v(_vm._s(_vm.trans("general.filter"))),
            ]),
            _vm._v(" "),
            _c("strong", [_vm._v(_vm._s(_vm.appliedFilterCount))]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.appliedFilterHint))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "section",
          {
            staticClass:
              "people-command-card people-command-card--muted sip-kpi",
          },
          [
            _c("span", { staticClass: "people-command-card__label" }, [
              _vm._v(_vm._s(_vm.trans("general.sort_by"))),
            ]),
            _vm._v(" "),
            _c("strong", [_vm._v(_vm._s(_vm.sortLabel))]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(_vm.orderLabel) +
                  " · " +
                  _vm._s(_vm.filterUserForm.page_length) +
                  " " +
                  _vm._s(_vm.trans("general.per_page"))
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.showFilterPanel
          ? _c(
              "div",
              {
                staticClass: "card-saas people-filter-card mb-2",
                attrs: { id: "user-filter-panel" },
              },
              [
                _c("div", { staticClass: "card-body" }, [
                  _c("h4", { staticClass: "card-saas__title" }, [
                    _vm._v(_vm._s(_vm.trans("general.filter"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-6 col-md-3 form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v(_vm._s(_vm.trans("user.first_name"))),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filterUserForm.first_name,
                            expression: "filterUserForm.first_name",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { name: "first_name" },
                        domProps: { value: _vm.filterUserForm.first_name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.filterUserForm,
                              "first_name",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6 col-md-3 form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v(_vm._s(_vm.trans("user.last_name"))),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filterUserForm.last_name,
                            expression: "filterUserForm.last_name",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { name: "last_name" },
                        domProps: { value: _vm.filterUserForm.last_name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.filterUserForm,
                              "last_name",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6 col-md-3 form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v(_vm._s(_vm.trans("user.email"))),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filterUserForm.email,
                            expression: "filterUserForm.email",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { name: "email" },
                        domProps: { value: _vm.filterUserForm.email },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.filterUserForm,
                              "email",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6 col-md-3 form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v(_vm._s(_vm.trans("role.role"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterUserForm.role_id,
                              expression: "filterUserForm.role_id",
                            },
                          ],
                          staticClass: "custom-select col-12",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.filterUserForm,
                                "role_id",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v(_vm._s(_vm.trans("general.select_one"))),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.roles, function (role) {
                            return _c(
                              "option",
                              { domProps: { value: role.id } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(role.name) +
                                    "\n                            "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6 col-md-3 form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v(_vm._s(_vm.trans("user.status"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterUserForm.status,
                              expression: "filterUserForm.status",
                            },
                          ],
                          staticClass: "custom-select col-12",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.filterUserForm,
                                "status",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v(_vm._s(_vm.trans("general.select_one"))),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "activated" } }, [
                            _vm._v(_vm._s(_vm.trans("user.status_activated"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "option",
                            { attrs: { value: "pending_activation" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.trans("user.status_pending_activation")
                                )
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "option",
                            { attrs: { value: "pending_approval" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.trans("user.status_pending_approval")
                                )
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "banned" } }, [
                            _vm._v(_vm._s(_vm.trans("user.status_banned"))),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "disapproved" } }, [
                            _vm._v(
                              _vm._s(_vm.trans("user.status_disapproved"))
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-6 col-md-6 form-group" },
                      [
                        _c("date-range-picker", {
                          attrs: {
                            "start-date":
                              _vm.filterUserForm.created_at_start_date,
                            "end-date": _vm.filterUserForm.created_at_end_date,
                            label: _vm.trans("user.created_at"),
                          },
                          on: {
                            "update:startDate": function ($event) {
                              return _vm.$set(
                                _vm.filterUserForm,
                                "created_at_start_date",
                                $event
                              )
                            },
                            "update:start-date": function ($event) {
                              return _vm.$set(
                                _vm.filterUserForm,
                                "created_at_start_date",
                                $event
                              )
                            },
                            "update:endDate": function ($event) {
                              return _vm.$set(
                                _vm.filterUserForm,
                                "created_at_end_date",
                                $event
                              )
                            },
                            "update:end-date": function ($event) {
                              return _vm.$set(
                                _vm.filterUserForm,
                                "created_at_end_date",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6 col-md-3 form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v(_vm._s(_vm.trans("general.sort_by"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterUserForm.sort_by,
                              expression: "filterUserForm.sort_by",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { name: "order" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.filterUserForm,
                                "sort_by",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "first_name" } }, [
                            _vm._v(_vm._s(_vm.trans("user.first_name"))),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "last_name" } }, [
                            _vm._v(_vm._s(_vm.trans("user.last_name"))),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "email" } }, [
                            _vm._v(_vm._s(_vm.trans("user.email"))),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "status" } }, [
                            _vm._v(_vm._s(_vm.trans("user.status"))),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "created_at" } }, [
                            _vm._v(_vm._s(_vm.trans("user.created_at"))),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6 col-md-3 form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v(_vm._s(_vm.trans("general.order"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterUserForm.order,
                              expression: "filterUserForm.order",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { name: "order" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.filterUserForm,
                                "order",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "asc" } }, [
                            _vm._v(_vm._s(_vm.trans("general.ascending"))),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "desc" } }, [
                            _vm._v(_vm._s(_vm.trans("general.descending"))),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.hasPermission("list-user") && _vm.users.total
        ? _c("div", { staticClass: "admin-list-table-card mt-2" }, [
            _c("div", { staticClass: "table-responsive" }, [
              _c("table", { staticClass: "table admin-data-table mb-0" }, [
                _c("thead", [
                  _c(
                    "tr",
                    [
                      _c(
                        "sortable-th",
                        {
                          attrs: {
                            field: "first_name",
                            "sort-by": _vm.filterUserForm.sort_by,
                            order: _vm.filterUserForm.order,
                          },
                          on: { sort: _vm.sortUsers },
                        },
                        [_vm._v(_vm._s(_vm.trans("user.name")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "sortable-th",
                        {
                          attrs: {
                            field: "email",
                            "sort-by": _vm.filterUserForm.sort_by,
                            order: _vm.filterUserForm.order,
                          },
                          on: { sort: _vm.sortUsers },
                        },
                        [_vm._v(_vm._s(_vm.trans("user.email")))]
                      ),
                      _vm._v(" "),
                      _c("th", [_vm._v(_vm._s(_vm.trans("role.role")))]),
                      _vm._v(" "),
                      _c(
                        "sortable-th",
                        {
                          attrs: {
                            field: "status",
                            "sort-by": _vm.filterUserForm.sort_by,
                            order: _vm.filterUserForm.order,
                          },
                          on: { sort: _vm.sortUsers },
                        },
                        [_vm._v(_vm._s(_vm.trans("user.status")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "sortable-th",
                        {
                          attrs: {
                            field: "created_at",
                            "sort-by": _vm.filterUserForm.sort_by,
                            order: _vm.filterUserForm.order,
                          },
                          on: { sort: _vm.sortUsers },
                        },
                        [_vm._v(_vm._s(_vm.trans("user.created_at")))]
                      ),
                      _vm._v(" "),
                      _c("th", { staticClass: "admin-table-actions-cell" }, [
                        _vm._v(_vm._s(_vm.trans("general.actions"))),
                      ]),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.users.data, function (user) {
                    return _c("tr", { key: user.id }, [
                      _c("td", [
                        _c("div", { staticClass: "people-table__identity" }, [
                          _c("img", {
                            staticClass: "people-table__avatar",
                            attrs: { src: _vm.getAvatar(user), alt: "" },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "people-table__copy" }, [
                            _c("div", {
                              staticClass: "people-table__primary",
                              domProps: {
                                textContent: _vm._s(
                                  user.profile.first_name +
                                    " " +
                                    user.profile.last_name
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "people-table__meta" }, [
                              _vm._v("#" + _vm._s(user.id)),
                            ]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", {
                          staticClass: "people-table__email",
                          domProps: { textContent: _vm._s(user.email) },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "ul",
                          { staticClass: "admin-table-role-list" },
                          _vm._l(user.roles, function (role) {
                            return _c("li", { key: role.id }, [
                              _vm._v(_vm._s(role.name)),
                            ])
                          }),
                          0
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        _vm._l(_vm.getUserStatus(user), function (status) {
                          return _c(
                            "span",
                            {
                              key: status.label,
                              class: [
                                "admin-status-badge",
                                "admin-status-badge--" + status.color,
                                "mr-1",
                              ],
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(status.label) +
                                  "\n                            "
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", { staticClass: "people-table__date" }, [
                          _vm._v(_vm._s(_vm._f("moment")(user.created_at))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "admin-table-actions-cell" },
                        [
                          _c(
                            "table-row-action-dropdown",
                            [
                              _c(
                                "b-dropdown-item",
                                { attrs: { to: "/user/" + user.id } },
                                [
                                  _c("admin-icon", { attrs: { name: "eye" } }),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.trans("user.view_user")) +
                                      "\n                                "
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.hasPermission("delete-user")
                                ? _c(
                                    "b-dropdown-item-button",
                                    {
                                      directives: [
                                        {
                                          name: "confirm",
                                          rawName: "v-confirm",
                                          value: {
                                            ok: _vm.confirmDelete(user),
                                          },
                                          expression:
                                            "{ok: confirmDelete(user)}",
                                        },
                                      ],
                                      staticClass: "admin-row-actions__danger",
                                    },
                                    [
                                      _c("admin-icon", {
                                        attrs: { name: "trash" },
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.trans("general.delete")) +
                                          "\n                                "
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ])
                  }),
                  0
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "admin-table-pagination-wrap" },
              [
                _c("pagination-record", {
                  attrs: {
                    "page-length": _vm.filterUserForm.page_length,
                    records: _vm.users,
                  },
                  on: {
                    "update:pageLength": function ($event) {
                      return _vm.$set(_vm.filterUserForm, "page_length", $event)
                    },
                    "update:page-length": function ($event) {
                      return _vm.$set(_vm.filterUserForm, "page_length", $event)
                    },
                    updateRecords: _vm.getUsers,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.users.total
        ? _c(
            "div",
            {
              staticClass: "admin-list-table-card admin-empty-state mt-2",
              attrs: { role: "status" },
            },
            [
              _c("div", { staticClass: "admin-empty-state__inner" }, [
                _c(
                  "div",
                  {
                    staticClass: "admin-empty-state__icon-wrap",
                    attrs: { "aria-hidden": "true" },
                  },
                  [_c("admin-icon", { attrs: { name: "users" } })],
                  1
                ),
                _vm._v(" "),
                _c("h4", { staticClass: "admin-empty-state__title" }, [
                  _vm._v(_vm._s(_vm.trans("user.module_info_title"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "admin-empty-state__text" }, [
                  _vm._v(_vm._s(_vm.trans("user.module_info_description"))),
                ]),
                _vm._v(" "),
                _vm.hasPermission("create-user")
                  ? _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "b-modal",
                            rawName: "v-b-modal.modal-1",
                            modifiers: { "modal-1": true },
                          },
                        ],
                        staticClass:
                          "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid mt-2",
                        attrs: { type: "button" },
                      },
                      [
                        _c("admin-icon", { attrs: { name: "plus" } }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.trans("user.create_user")) +
                            "\n            "
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-1",
            "hide-footer": "",
            size: "lg",
            centered: "",
            "modal-class": "admin-modal-pro",
            "content-class": "admin-modal-pro__content",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [_vm._v(_vm._s(_vm.trans("user.add_new_user")))]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.submit.apply(null, arguments)
                },
                keydown: function ($event) {
                  return _vm.userForm.errors.clear($event.target.name)
                },
              },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6 form-group" },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v(_vm._s(_vm.trans("user.first_name"))),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userForm.first_name,
                          expression: "userForm.first_name",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        value: "",
                        name: "first_name",
                        placeholder: _vm.trans("user.first_name"),
                      },
                      domProps: { value: _vm.userForm.first_name },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.userForm,
                            "first_name",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("show-error", {
                      attrs: {
                        "form-name": _vm.userForm,
                        "prop-name": "first_name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6 form-group" },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v(_vm._s(_vm.trans("user.last_name"))),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userForm.last_name,
                          expression: "userForm.last_name",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        value: "",
                        name: "last_name",
                        placeholder: _vm.trans("user.last_name"),
                      },
                      domProps: { value: _vm.userForm.last_name },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.userForm,
                            "last_name",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("show-error", {
                      attrs: {
                        "form-name": _vm.userForm,
                        "prop-name": "last_name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-12 form-group" },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v(_vm._s(_vm.trans("user.email"))),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userForm.email,
                          expression: "userForm.email",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        value: "",
                        name: "email",
                        placeholder: _vm.trans("user.email"),
                      },
                      domProps: { value: _vm.userForm.email },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.userForm, "email", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("show-error", {
                      attrs: {
                        "form-name": _vm.userForm,
                        "prop-name": "email",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6 form-group" },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v(_vm._s(_vm.trans("user.password"))),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userForm.password,
                          expression: "userForm.password",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "password",
                        value: "",
                        name: "password",
                        placeholder: _vm.trans("user.password"),
                      },
                      domProps: { value: _vm.userForm.password },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.userForm,
                            "password",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("show-error", {
                      attrs: {
                        "form-name": _vm.userForm,
                        "prop-name": "password",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6 form-group" },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v(_vm._s(_vm.trans("user.password_confirmation"))),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userForm.password_confirmation,
                          expression: "userForm.password_confirmation",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "password",
                        value: "",
                        name: "password_confirmation",
                        placeholder: _vm.trans("user.password_confirmation"),
                      },
                      domProps: { value: _vm.userForm.password_confirmation },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.userForm,
                            "password_confirmation",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("show-error", {
                      attrs: {
                        "form-name": _vm.userForm,
                        "prop-name": "password_confirmation",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6 form-group" },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v(_vm._s(_vm.trans("role.role"))),
                    ]),
                    _vm._v(" "),
                    _c("v-select", {
                      attrs: {
                        label: "name",
                        "track-by": "id",
                        name: "role_id",
                        id: "role_id",
                        options: _vm.roles,
                        placeholder: _vm.trans("role.select_role"),
                        multiple: true,
                        "close-on-select": false,
                        "clear-on-select": false,
                        "hide-selected": true,
                        selected: _vm.selected_roles,
                      },
                      on: {
                        select: _vm.onRoleSelect,
                        remove: _vm.onRoleRemove,
                      },
                      model: {
                        value: _vm.selected_roles,
                        callback: function ($$v) {
                          _vm.selected_roles = $$v
                        },
                        expression: "selected_roles",
                      },
                    }),
                    _vm._v(" "),
                    _c("show-error", {
                      attrs: {
                        "form-name": _vm.userForm,
                        "prop-name": "role_id",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6 form-group" },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v(_vm._s(_vm.trans("user.address_line_1"))),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userForm.address_line_1,
                          expression: "userForm.address_line_1",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        value: "",
                        name: "address_line_1",
                        placeholder: _vm.trans("user.address_line_1"),
                      },
                      domProps: { value: _vm.userForm.address_line_1 },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.userForm,
                            "address_line_1",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("show-error", {
                      attrs: {
                        "form-name": _vm.userForm,
                        "prop-name": "address_line_1",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6 form-group" },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v(_vm._s(_vm.trans("user.address_line_2"))),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userForm.address_line_2,
                          expression: "userForm.address_line_2",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        value: "",
                        name: "address_line_2",
                        placeholder: _vm.trans("user.address_line_2"),
                      },
                      domProps: { value: _vm.userForm.address_line_2 },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.userForm,
                            "address_line_2",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("show-error", {
                      attrs: {
                        "form-name": _vm.userForm,
                        "prop-name": "address_line_2",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6 form-group" },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v(_vm._s(_vm.trans("user.city"))),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userForm.city,
                          expression: "userForm.city",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        value: "",
                        name: "city",
                        placeholder: _vm.trans("user.city"),
                      },
                      domProps: { value: _vm.userForm.city },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.userForm, "city", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("show-error", {
                      attrs: { "form-name": _vm.userForm, "prop-name": "city" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6 form-group" },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v(_vm._s(_vm.trans("user.state"))),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userForm.state,
                          expression: "userForm.state",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        value: "",
                        name: "state",
                        placeholder: _vm.trans("user.state"),
                      },
                      domProps: { value: _vm.userForm.state },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.userForm, "state", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("show-error", {
                      attrs: {
                        "form-name": _vm.userForm,
                        "prop-name": "state",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6 form-group" },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v(_vm._s(_vm.trans("user.zipcode"))),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userForm.zipcode,
                          expression: "userForm.zipcode",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        value: "",
                        name: "zipcode",
                        placeholder: _vm.trans("user.zipcode"),
                      },
                      domProps: { value: _vm.userForm.zipcode },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.userForm, "zipcode", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("show-error", {
                      attrs: {
                        "form-name": _vm.userForm,
                        "prop-name": "zipcode",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6 form-group" },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v(_vm._s(_vm.trans("user.country"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userForm.country_id,
                            expression: "userForm.country_id",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { name: "country_id" },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.userForm,
                              "country_id",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v(_vm._s(_vm.trans("user.country"))),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.countries, function (country) {
                          return _c(
                            "option",
                            { domProps: { value: country.value } },
                            [_vm._v(_vm._s(country.text))]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("show-error", {
                      attrs: {
                        "form-name": _vm.userForm,
                        "prop-name": "country_id",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "admin-modal-pro__footer" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                    attrs: { type: "submit" },
                  },
                  [_vm._v(_vm._s(_vm.trans("general.add")))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "admin-modal-pro__footer-extra" },
                  [
                    _c("switches", {
                      attrs: { theme: "bootstrap", color: "success" },
                      model: {
                        value: _vm.userForm.send_email,
                        callback: function ($$v) {
                          _vm.$set(_vm.userForm, "send_email", $$v)
                        },
                        expression: "userForm.send_email",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "admin-modal-pro__switch-label" },
                      [_vm._v(_vm._s(_vm.trans("user.send_welcome_email")))]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }